const highlights = [
    {
        date: 'October 2025',
        highlight: `I returned to my PhD after a six-month Data Science internship with the {text}
                    evaluating algorithmic bias in Large Language Models.`,
        url: 'https://www.gov.uk/government/organisations/ministry-of-justice',
        link_text: 'UK Ministry of Justice'
    },
    {
        date: 'July 2025',
        highlight: `My paper titled '{text}' was accepted into PETS 2025.`,
        link_text: 'Exploring Privacy Behaviours, Awareness, and Concerns Among UK Users of LLM-based Conversational Agents',
        url: 'https://petsymposium.org/popets/2025/popets-2025-0160.php'

    },
    {
        date: 'March 2025',
        highlight: 'I was a panellist at the {text} at the European Comission.',
        link_text: 'CPDP Data Protection Day',
        url: 'https://www.edps.europa.eu/press-publications/press-news/videos/cpdp-dpd-2025-whos-watching-your-period_en'
    },
    {
        date: 'May 2024',
        highlight: `My paper '{text}' was accepted into CHI 2024. The findings went on to be covered by the BBC.`,
        link_text: 'Exploring Privacy Practices of Female mHealth Apps in a Post-Roe World',
        url: 'https://dl.acm.org/doi/10.1145/3613904.3642521'
    }
]

export default highlights;